import { render, staticRenderFns } from "./changeTbRecord.vue?vue&type=template&id=f19dae24&scoped=true"
import script from "./changeTbRecord.vue?vue&type=script&lang=js"
export * from "./changeTbRecord.vue?vue&type=script&lang=js"
import style0 from "./changeTbRecord.vue?vue&type=style&index=0&id=f19dae24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19dae24",
  null
  
)

export default component.exports